import { Backdrop, CircularProgress } from "@material-ui/core";

const Loading = ({ loading }) => {
  return (
    <Backdrop
      style={{
        color: (theme) => theme.palette.common.principal,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        background: "rgba(0,0,0,0.1)",
      }}
      open={loading}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default Loading;
